<template>
<div class="page_">
    <div class="form_con">
        <a-form layout="inline" @submit="handleSubmit" :form="form">
            <a-form-item label="证件类型">
               <a-select style="width:216px;margin-bottom:20px;" placeholder="请选择证件类型"  v-decorator="[
                'type',
                {
                  rules: [{ required: true, message: '请选择证件类型' }]
                }
              ]">
                 <a-select-option v-for="item in idTypeOptions":value="item.value">{{item.name}}</a-select-option>
               </a-select>
            </a-form-item>
            <a-form-item label="证件号码">
                <a-input style="width:216px;height:30px;line-height:30px;" placeholder="请输入证件号码" v-decorator="[
                'idNumber',
                {
                  rules: [{ required: true, message: '请输入证件号码' }]
                }
              ]"></a-input>
            </a-form-item>
            <a-form-item style="width:167px;height:42px;line-height:42px;margin:37px auto 0;display:block;">
                <a-button type="primary"style="width:167px;height:42px;line-height:42px;" html-type="submit">确定</a-button>
            </a-form-item>
        </a-form>
    </div>
</div>
</template>
<style lang="scss" scoped>
  .form_con{
    width:315px;
    margin:0 auto;
    .ant-form-item{
      display:block;
    }
  }
</style>
<script>
import navbar from '../components/navbar'
import api from '@/utils/api'
export default {
    data () {
        document.title = '添加证件'
        return {
            idTypeOptions: [
              {
                name: "身份证",
                value: "1"
              },
              {
                name: "护照",
                value: "2"
              },
              {
                name: "台湾通行证",
                value: "6"
              },
              {
                name: "港澳通行证",
                value: "4"
              },
            ],
            form: this.$form.createForm(this),
        }
    },
    components: {
        navbar
    },
    methods: {
        handlePageChange (e) {
            console.log('handlePageChange -> ', e)
        },
        handleSubmit(e) {
            e && e.preventDefault();
            this.form.validateFields((error, values) => {
              if (!error) {
                if(values.type==='1'){
                  let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
                  if(idcardReg.test(values.idNumber)) {
                    let requestData={idNumber:values.idNumber,type:values.type}
                    console.log(requestData,'requestData')
                    api.updCertificateInfo(requestData).then(res => res.data).then(data => {
                      if(data.code==='0000'){
                          this.$notification.open({
                              message: '证件更新提醒',
                              description:data.msg,
                              duration: 2,
                          });
                           this.form.resetFields()
                        }else{
                        this.$notification.open({
                            message: '证件更新提醒',
                            description:data.returnMsg,
                            duration: 2,
                        });
                      }
                    })
                  }else{
                    this.$notification.open({
                        message: '输入提醒',
                        description:'身份证号码不合法，请重新输入',
                        duration: 2,
                    });
                  }
                }else{
                  let requestData={idNumber:values.idNumber,type:values.type}
                  console.log(requestData,'requestData')
                  api.updCertificateInfo(requestData).then(res => res.data).then(data => {
                    console.log(data,'data---')
                      if(data.returnCode==='0000'){
                        this.$notification.open({
                            message: '证件更新提醒',
                            description:data.returnMsg,
                            duration: 2,
                        });
                        this.form.resetFields()
                      }else{
                        this.$notification.open({
                            message: '证件更新提醒',
                            description:data.returnMsg,
                            duration: 2,
                        });
                      }
                  })
                }
              }
          });
        },
    }
}
</script>